import React from 'react'

export default function FormIconMagnifyingGlass (props) {
  return (
    <svg
      width="67"
      height="69"
      viewBox="0 0 67 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <circle
        cx="27.007"
        cy="27.007"
        r="26.007"
        transform="matrix(-1 0 0 1 54.0137 0)"
        fill="white"
        stroke="#1D1F21"
        strokeWidth="2"
      />
      <mask
        id="mask0_6532_9430"
        maskType="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="50"
        height="50"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          transform="matrix(-1 0 0 1 52 2)"
          fill="#FFFFFF"
        />
      </mask>
      <g mask="url(#mask0_6532_9430)">
        <path d="M-11 16H24.2155L37 28.7807V78L-11 78V16Z" fill="#61C9D7" />
        <path d="M24 16L24 29L37 29L24 16Z" fill="#05AAC0" />
        <path d="M24 16L24 29L37 29L24 16Z" stroke="white" />
      </g>
      <line
        y1="-1"
        x2="31.0729"
        y2="-1"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 65 68.1826)"
        stroke="#1D1F21"
        strokeWidth="2"
      />
    </svg>
  )
}
